import commonConfig from "config/common.js";
import get from "lodash/get";
import { setFieldProperty } from "egov-ui-kit/redux/form/actions";

const formConfig = {
  name: "register",
  fields: {
    name: {
      id: "person-name",
      type: "textfield",
      jsonPath: "otp.name",
      required: true,
      floatingLabelText: "CORE_COMMON_NAME",
      errorMessage: "CORE_COMMON_NAME_VALIDMSG",
      hintText: "CORE_COMMON_NAME_PLACEHOLDER",
      pattern: "^([^-!#$%&()*,./:;?@[\\]_{|}¨ˇ“”€+<=>§°\\d\\s¤®™©]| )+$",
    },
    city: {
      id: "person-city",
      jsonPath: "otp.permanentCity",
      required: true,
      floatingLabelText: "CORE_COMMON_CITY",
      hintText: "CORE_COMMON_CITY_PLACEHOLDER",
      value: "km.kolkata",
    },
    tenant: {
      jsonPath: "otp.tenantId",
      value: commonConfig.tenantId,
    },
    phone: {
      id: "person-phone",
      required: true,
      type: "mobilenumber",
      jsonPath: "otp.mobileNumber",
      floatingLabelText: "CORE_COMMON_MOBILE_NUMBER",
      errorMessage: "Invalid Mobile No.",
      hintText: "CORE_COMMON_PHONE_NUMBER_PLACEHOLDER",
      pattern: "[1-9]{1}[0-9]{9}",
      maxLength: "10",
    },
    generatedCaptcha: {
      id: "person-generatedCaptcha",
      required: true,
      type: "textfield",
      jsonPath: "otp.generatedCaptcha",
      floatingLabelText: "",
      errorMessage: "Invalid Captcha",
      hintText: "",
      maxLength: "10",
    },
    captcha: {
      id: "captcha",
      required: true,
      type: "textfield",
      jsonPath: "otp.captcha",
      floatingLabelText: "Captcha",
      errorMessage: "Invalid Captcha",
      hintText: "Captcha",
      pattern: true,
      updateDependentFields: ({ formKey, field, dispatch, state }) => {
        const generatedCaptcha = get(state, "form.register.fields.generatedCaptcha.value", "");
        const captchaValue = get(state, "form.register.fields.captcha.value", "");

     if (captchaValue == generatedCaptcha){
           dispatch(setFieldProperty("register", "captcha", "pattern", false))
           dispatch(setFieldProperty("register", "captcha", "errorText", ""))
       } else{
         dispatch(setFieldProperty("register", "captcha", "pattern", true));
          dispatch(setFieldProperty("register", "captcha", "errorText", "Invalid Captcha"))
       }
      },
    },
    type: {
      id: "otp-type",
      jsonPath: "otp.type",
      value: "register",
    },
  },
  submit: {
    label: "CORE_COMMON_CONTINUE",
    id: "login-submit-action",
    type: "submit",
  },
  action: "_send",
  saveUrl: "/user-otp/v1/_send",
  redirectionRoute: "/user/otp",
  afterInitForm: (action, store, dispatch) => {},
};

export default formConfig;



// WEBPACK FOOTER //
// ./src/config/forms/specs/register.js